function checkPhone(phoneNum) {
	if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phoneNum))) {
		return false;
	}
	return true
}

/**
 * json 转 表单参数格式
 * */
function jsonConvertForm(jsonObj) {
	let convertRet = "";
	if (typeof(jsonObj) === "object") {
		for (let key in jsonObj) {
			if (typeof jsonObj[key] === "object") {
				convertRet += "&" + key + "=" + JSON.stringify(jsonObj[key]);
			} else {
				convertRet += "&" + key + "=" + jsonObj[key];
			}
		}
		if (convertRet.length > 0) {
			convertRet = convertRet.substring(1)
		}
	}
	return convertRet;
}


/**
 * 根据参数名称获取地址对应参数值
 * 若没找到对应值则返回null
 * @method   getQueryString
 * @Author   chenguangchao
 * @DateTime 2020-11-09
 * @param    string       name [参数名]
 * @return   string       value [参数值]
 */
function utc2beijing(utc_datetime) {
	var dateee = new Date(utc_datetime).toJSON();
	return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
}

/* [格式化时间对象为年,月,天,小时,分钟]
 * @method   formatTimeToStr
 * @Author   chenguangchao
 * @DateTime 2020-11-09
 * @param    {[type]}      dateObj [毫秒数]
 * @return   {[type]}      [年|月|天|小时|分钟]
 */
function formatTimeToStr(dateObj) {
	var dataObj = {};
	let year = dateObj.getFullYear();
	let month = dateObj.getMonth() + 1;
	let day = dateObj.getDate() < 10 ? '0' + dateObj.getDate() : dateObj.getDate();
	let hour = dateObj.getHours() < 10 ? '0' + dateObj.getHours() : dateObj.getHours();
	let minute = dateObj.getMinutes() < 10 ? '0' + dateObj.getMinutes() : dateObj.getMinutes();
	let second = dateObj.getSeconds() < 10 ? '0' + dateObj.getSeconds() : dateObj.getSeconds();
	return year + "." + month + "." + day + " " + hour + ":" + minute + ":" + second
}

/* [获取当前年,月,天,小时,分钟] */
function getNowDate(type) {
	var str = "";
	var weekList = ["日", "一", "二", "三", "四", "五", "六"];
	var date = new Date();
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var day = date.getDate();
	var week = date.getDay();
	var hours = date.getHours();
	var minutes = date.getMinutes();
	var seconds = date.getSeconds();

	month = month > 9 ? month : "0" + month;
	day = day > 9 ? day : "0" + day;
	seconds = seconds > 9 ? seconds : "0" + seconds;
	minutes = minutes > 9 ? minutes : "0" + minutes;
	hours = hours > 9 ? hours : "0" + hours;
	// str += year + "年" + month + "月" + day + "日" + "星期" + weekList[week] + hours + ":" + minutes + ":" + seconds;
	if (type == 'ymd') {
		return year + '-' + month + '-' + day;
	} else if (type == 'ym') {
		return year + '-' + month;
	}
}

/* [将给定的数组分割成，指定长度的二维数组]
 * @method   dataSourceSplitForLen
 * @Author   chenguangchao
 * @DateTime 2021-02-05
 * @param    {[JSONArray||Array]}  dataAry [源数组]
 * @param    {[Number]}  len [指定分割的长度]
 * @return   {[JSONArray||Array]}  [分割后的新数组]
 */
function dataSourceSplitForLen(dataAry, len) {
	let newArr = [] //首先创建一个新的空数组。用来存放分割好的数组
	for (let i = 0; i < dataAry.length;) { //注意：这里与for循环不太一样的是，没有i++
		newArr.push(dataAry.slice(i, i += len));
	}
	return newArr
}

// 去除0 参数 日期 如 2020-07-08 返回为 2020-7-8
function dislodgeZero(str) {
	let strArray = str.split("-");
	strArray = strArray.map(function(val) {
		if (val[0] == "0") {
			return (val = val.slice(1));
		} else {
			return val;
		}
	});
	return strArray.join("-");
}

// 中国标准时间（Thu May 12 2016 08:00:00 GMT+0800 ）转化为yyyy-MM-dd格式
function chinaStandard(str) {
	var date = new Date(str);
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? ('0' + m) : m;
	var d = date.getDate();
	d = d < 10 ? ('0' + d) : d;
	var h = date.getHours();
	var minute = date.getMinutes();
	minute = minute < 10 ? ('0' + minute) : minute;
	let time = y + '-' + m + '-' + d; //这里如果不需要小时 分  后边的可以不需要拼接
	return time;
}

/**
 * 判断日期是否在当前月份
 * @returns {boolean} - 返回是否满足条件
 */
function isSameMonth(inDate) {
	var nowDate = new Date();
	return ((nowDate.getFullYear() == inDate.getFullYear()) && (nowDate.getMonth() == inDate.getMonth()));
}
/**
 * 判断日期是否在当前月份，并且是否在包括今天在内的七天之内（不包括今天之后的日期）
 * @param {string | Date} date - 目标日期（可以是字符串或 Date 对象）
 * @returns {boolean} - 返回是否满足条件
 */
function isDateInCurrentMonthAndWithinSevenDays(date) {
	// 将目标日期转换为 Date 对象
	const targetDate = new Date(date);
	if (isNaN(targetDate.getTime())) {
		throw new Error('Invalid date');
	}

	// 获取当前日期（去掉时间部分，只保留日期）
	const currentDate = new Date();
	currentDate.setHours(0, 0, 0, 0); // 将时间部分设置为 00:00:00

	// 判断是否在当前月份
	const isInCurrentMonth =
		targetDate.getFullYear() === currentDate.getFullYear() &&
		targetDate.getMonth() === currentDate.getMonth();

	// 判断是否在包括今天在内的七天之内（不包括今天之后的日期）
	const timeDiff = targetDate.getTime() - currentDate.getTime();
	const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24)); // 计算天数差
	const isWithinSevenDays = dayDiff >= -6 && dayDiff <= 0;

	// 返回结果
	return isInCurrentMonth && isWithinSevenDays;
}

export default { //注意这里是default
	jsonConvertForm,
	utc2beijing,
	checkPhone,
	formatTimeToStr,
	dataSourceSplitForLen,
	getNowDate,
	dislodgeZero,
	chinaStandard,
	isSameMonth,
	isDateInCurrentMonthAndWithinSevenDays
}